module.exports = __webpack_public_path__ + "img/st.fa89864d.svg";